<template>
    <q-modal v-model="show_modal" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '90vh'}" @hide="hideModal()">
        <q-modal-layout>
            <q-toolbar slot="header">
                <q-btn flat round dense @click="hideModal()" icon="fas fa-times" />
                <q-toolbar-title>
                    {{ material.title }}
                </q-toolbar-title>
            </q-toolbar>

            <div class="layout-padding">
                <div class="row gutter-md">
                    <div class="col-xs-12 col-sm-4">
                        <q-card class="full-height">
                            <q-card-actions class="justify-center">
                                <q-btn flat :label="material.size" icon="fal fa-hdd" />
                                <q-btn flat :label="material.hits" icon="fal fa-download" />
                                <q-btn flat :label="material.extension" :icon="$extensionIcon(material.extension)" />
                            </q-card-actions>

                            <q-card-separator />

                            <q-card-actions class="justify-center">
                                <q-btn class="full-width q-my-sm" :label="$t('download')" icon="fal fa-download" color="primary" @click="downloadFile()" />
                            </q-card-actions>
                        </q-card>
                    </div>

                    <div class="col-xs-12 col-sm-8">
                        <q-card>
                            <q-card-main class="card-players">
                                <pdf-player :file_url="material.resource_url" :file_preview="material.file_preview" v-if="showPlayer(['pdf'])" :change_state="material.change_state" />

                                <office-player
                                    :file_url="material.resource_url"
                                    v-else-if="showPlayer(['ppt', 'pptx', 'doc', 'docx', 'xls', 'xlsx'])"
                                />

                                <image-player
                                    :file_url="material.resource_url"
                                    v-else-if="showPlayer(['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg'])"
                                />

                                <video-player
                                    :file_url="material.resource_url"
                                    :id="material.id"
                                    v-else-if="showPlayer(['mp4'])"
                                />

                                <div v-else class="q-mt-xl">
                                    <p><q-icon name="fal fa-eye-slash" size="3rem" /></p>
                                    <p class="q-display-1 text-weight-medium">
                                        {{ $t('no_pre_visualization_avaliable') }}
                                    </p>
                                </div>
                            </q-card-main>
                        </q-card>
                    </div>
                </div>
            </div>
        </q-modal-layout>
    </q-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import Pdf from 'components/players/Pdf'
import Office from 'components/players/Office'
import Image from 'components/players/Image'
import Video from 'components/players/Video'

export default {
    props: ['material', 'show'],

    data() {
        return {
        }
    },

    components: {
        'pdf-player': Pdf,
        'office-player': Office,
        'image-player': Image,
        'video-player': Video
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        show_modal: {
            get() {
                return this.show
            },
            set(val) {
                this.$emit('hideModal', '')
            }
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '80vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        },
    },

    methods: {
        downloadFile() {
            let file = this.material.resource_url_download.substring(this.material.resource_url_download.lastIndexOf('/')+1)
            let extension = file.substring(file.lastIndexOf('.'))
            let fileName = `${this.material.title}${extension}`

            if (this.$q.platform.is.cordova) {
                cordova.InAppBrowser.open(this.material.resource_url_download, '_system', 'usewkwebview=yes,hidenavigationbuttons=yes,toolbar=no')
                this.hitDownload()
            }
            else {
                window.open(this.material.resource_url_download, '_blank')
                this.hitDownload()
            }
        },

        hitDownload() {
            this.$axios.get(`/etraining_courses/group_training/${this.$route.params.id}/group_training_material/${this.material.id}/request_group_training_material_download/`, this.getHeader)
            .then(response => {

            })
            .catch(e => {
                console.log(e)
            })
        },

        hideModal() {
            this.$emit('hideModal', '')
        },

        showPlayer(type) {
            let obj = type.find((obj) => { return obj === this.material.extension })
            if (obj) return true
            else return false
        }
    }
}
</script>

<style lang="stylus" scoped>
.card-players
    height 600px
    text-align center
</style>
